import React from 'react';

const IconTask = props => (<svg viewBox="0 0 22 22" width="22px" height="22px" {...props}>
  <path d="M10.999 10.157c-2.499-0.956-5.227-0.956-7.726 0v9.842c2.499-0.956 5.227-0.956 7.726 0 c2.498-0.956 5.227-0.956 7.726 0v-9.842C16.226 9.201 13.496 9.201 10.999 10.157z" />
  <path d="M16.913 5.462V2.361h-1.893v1.996l-4.022-2.348l-9 5.255l0.972 1.583l8.028-4.688l8.028 4.688l0.973-1.583 L16.913 5.462z" />
</svg>);

export default IconTask;
